module.exports = "/images/breezeline2.webp?88c6a44844d7bca9543e27f76d9fe4f2";